import { useEffect, useState } from 'react';
import { useGameStore } from 'store';
import { GameStatus } from '@/components/types';
import { Game } from '@/_models/Game';
import GameAnalyticService from '@/components/tour/game/services/GameAnalyticService';

type Props = {
  game: Game;
  analytic: GameAnalyticService;
  gameStatus: GameStatus;
  onEndExperience: () => void;
};

const useGame = ({ game, analytic, gameStatus, onEndExperience }: Props) => {
  const [gameTime, setGameTime] = useState<number>(0);
  const lockTimer = useGameStore((state) => state.lockTimer);
  const setLockTimer = useGameStore((state) => state.setLockTimer);

  // 2nd level
  const initGameData = () => {
    const limitTime = game.limitTime * 60 * 1000;
    const currentGameTime = game.timerType === 'stopwatch' ? 1 : limitTime;
    setGameTime(currentGameTime);
    analytic.setTime(game.timerType === 'stopwatch' ? 1 : 0);
  };

  const mainGameTimer = () => {
    if (
      gameStatus === GameStatus.SuccessfullyEndedWithoutFinalScreen ||
      gameStatus === GameStatus.NotStarted
    ) {
      return;
    }

    if (lockTimer?.running && lockTimer?.value) {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      setLockTimer((lockTimer: any) => {
        if (lockTimer?.running && lockTimer?.value)
          return { running: lockTimer.running, value: lockTimer.value - 1 };
        return lockTimer;
      });
    }

    let currentGameTime = gameTime;
    if (game.timerType === 'stopwatch') currentGameTime += 1000;
    else currentGameTime -= 1000;

    analytic.setTime(
      game.timerType === 'stopwatch'
        ? currentGameTime
        : game.limitTime * 60 * 1000 - currentGameTime,
    );
    if (currentGameTime > 0 && (!game.limitTime || currentGameTime < game.limitTime * 60 * 1000)) {
      setGameTime(currentGameTime);
    } else {
      // end experience setstate result screen
      onEndExperience();
    }
  };

  useEffect(() => {
    if (gameStatus === GameStatus.Started) {
      initGameData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameStatus]);

  useEffect(() => {
    const timerInterval = setTimeout(mainGameTimer, 1000);
    return function cleanup() {
      clearTimeout(timerInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameTime]);

  return {
    gameTime,
  };
};

export default useGame;
